export const REVENUE_REASONS_QUERY_KEY = 'revenueReasons'
